export default "__VITE_ASSET__CVi1TtBM__"